import { get } from 'lodash';
import { retrieveObjectMapper, convertObjToCamelCase } from '../..';

export const transformPOCUsers = ({ data = [], users = [] }) =>
  data?.map(dt => {
    const user = users?.find(({ id }) => id === dt?.fk_user);
    return {
      ...retrieveObjectMapper(dt, ['ID:id', 'fk_user', 'staff_id']),
      userByFkUser: user && {
        ...retrieveObjectMapper(user, ['ID:id', 'firstname', 'lastname']),
      },
    };
  });

export const transformFindAllReportingStaff = ({ resp = {}, users = [] }) => {
  return {
    findAllReportingStaff: {
      totalCount: get(resp, 'data.totalCount', 0),
      data: get(resp, 'data.data', []).map(item => {
        const userDetails = users.find(user => user.id === item.fk_user);
        return {
          ...convertObjToCamelCase(item),
          userByFkUser: {
            ...convertObjToCamelCase(userDetails),
          },
        };
      }),
    },
  };
};

export const transformLinkpassSn2UserInfoResponse = (responseData = {}) => {
  return {
    linkpassSn2UserInfo: {
      LinkPassAuthTokenClaimDto: retrieveObjectMapper(
        get(responseData, 'LinkPassAuthTokenClaimDto', {}),
        ['UID', 'Name', 'Email', 'CountryCode', 'PhoneNumber']
      ),
      User: retrieveObjectMapper(get(responseData, 'User', {}), [
        'ID:id',
        'firstname',
        'lastname',
        'email',
        'mobilePhone:mobile_phone',
        'mobilePhoneCountryCode:mobile_phone_country_code',
      ]),
      LinkPassCompareWithUser: retrieveObjectMapper(
        get(responseData, 'LinkPassCompareWithUser', {}),
        ['IsDiffEmail', 'IsDiffPhone']
      ),
    },
  };
};

export const transformRegisterWithLinkPassInfo = (responseData = {}) => {
  return {
    data: {
      registerWithLinkPassInfo: {
        LinkPassAuthTokenClaimDto: retrieveObjectMapper(
          get(responseData, 'LinkPassAuthTokenClaimDto', {}),
          ['UID', 'Name', 'Email', 'CountryCode', 'PhoneNumber']
        ),
        User: retrieveObjectMapper(get(responseData, 'User', {}), [
          'ID:id',
          'firstname',
          'lastname',
          'email',
          'mobilePhone:mobile_phone',
          'mobilePhoneCountryCode:mobile_phone_country_code',
        ]),
        LinkPassCompareWithUser: retrieveObjectMapper(
          get(responseData, 'LinkPassCompareWithUser', {}),
          ['IsDiffEmail', 'IsDiffPhone']
        ),
      },
    },
    success: true,
  };
};

export default { transformPOCUsers };
